import {State} from "./State";

export const selectProfilerStateFromMainState = (mainState: any): State => mainState.profilerState;